// extracted by mini-css-extract-plugin
module.exports = {"hero":"workdetail_hero__27GyX","info":"workdetail_info__j7sQj","highlights":"workdetail_highlights__3Oh8Q"};